






















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {SoundItem} from "@/store/call/sounds/types";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CallSoundsFilter from "@/components/Call/Filters/CallSoundsFilter.vue";

@Component({components: {CallSoundsFilter, ScrollButton}})
export default class CallSounds extends BaseItemsPage<SoundItem> {
  @Getter("sounds") soundsResponse!: SoundItem[];

  is_show_filter = false;
  currentSort = 'id';
  currentSortOrder = 'desc';
  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return ["name", "path", "partner"];
  }

  getData(): SoundItem[] {
    return this.soundsResponse;
  }
}
